module.exports = __webpack_public_path__ + "static/media/curFormacion.cba3ca59.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curFormacion.png
// module id = 797
// module chunks = 0